import { useEffect } from "react";

const MARKS = ["◐", "◓", "◑", "◒"];
export const REDUCED = typeof window !== "undefined" && window.matchMedia?.("(prefers-reduced-motion: reduce)").matches;
export const PARTICLES = typeof navigator !== "undefined" && navigator.hardwareConcurrency && navigator.hardwareConcurrency <= 4 ? 6 : 14;

const setText = (n, v) => { if (n._v !== v) { n._v = v; n.textContent = v; } };

// Un solo rAF por loader; solo transform/opacity (y background-position del piso). Estado vía ref.
export function useHitFx(rootRef, stateRef) {
  useEffect(() => {
    const root = rootRef.current;
    if (!root) return undefined;
    const q = (s) => Array.from(root.querySelectorAll(`[data-fx="${s}"]`));
    const el = {
      ring: q("ring"), ring2: q("ring2"), floor: q("floor"), blink: q("blink"), front: q("front"),
      back1: q("back1"), back2: q("back2"), sheen: q("sheen"), hex: q("hex"), p: q("p"),
      pct: q("pct"), status: q("status"), sr: q("sr"),
      scan: q("scan").map((n) => [n, n.parentElement.offsetHeight]),
      bar: q("bar").map((b) => Array.from(b.children)),
      step: q("step").map((n) => [n, n.querySelector('[data-fx="mark"]')]),
    };
    const t0 = performance.now();
    let raf = 0;
    const loop = (now) => {
      raf = requestAnimationFrame(loop);
      const t = (now - t0) / 1000;
      const s = stateRef.current;
      const det = s.progress != null;
      const p = s.done ? 1 : det ? Math.max(0, Math.min(1, s.progress)) : 0;
      el.scan.forEach(([n, h]) => { n.style.transform = `translateY(${(Math.sin(t * (REDUCED ? 0.8 : 2.2)) * 0.5 + 0.5) * (h - 2)}px)`; });
      if (!REDUCED) {
        el.ring.forEach((n) => { n.style.transform = `rotate(${t * 40}deg)`; });
        el.ring2.forEach((n) => { n.style.transform = `rotate(${-t * 26}deg)`; });
        el.floor.forEach((n) => { n.style.backgroundPositionY = `${(t * 30) % 34}px`; });
        el.blink.forEach((n) => { n.style.opacity = Math.sin(t * 5) > 0 ? 1 : 0.35; });
        el.front.forEach((n) => { n.style.transform = `translateY(${Math.sin(t * 1.3) * 6}px) rotateY(${Math.sin(t * 0.9) * 16}deg) rotateX(${Math.cos(t * 0.7) * 6}deg)`; });
        const sh = Math.sin(t * 1.7);
        el.back1.forEach((n) => { n.style.transform = `translateX(${-18 - sh * 14}px) rotate(${-9 - sh * 5}deg)`; });
        el.back2.forEach((n) => { n.style.transform = `translateX(${18 + sh * 14}px) rotate(${9 + sh * 5}deg)`; });
        el.sheen.forEach((n) => { n.style.transform = `translateX(${(((t * 0.45) % 1.6) * 100 - 70) / 0.6}%)`; });
        const k = Math.floor(t * 8);
        el.hex.forEach((n) => { if (n._k !== k) { n._k = k; n.textContent = "0x" + Math.floor(Math.random() * 65535).toString(16).toUpperCase().padStart(4, "0"); } });
        el.p.forEach((n, i) => { const y = (t * 0.12 + i * 0.137) % 1; n.style.transform = `translateY(${-y * 320}px)`; n.style.opacity = Math.sin(y * Math.PI) * 0.9; });
      }
      el.pct.forEach((n) => setText(n, det || s.done ? String(Math.round(p * 100)).padStart(2, "0") : "··"));
      el.bar.forEach((cells) => cells.forEach((c, i) => {
        const on = det || s.done ? i / 20 < p : ((i - t * 14) % 20 + 20) % 20 < 5;
        if (c._on !== on) { c._on = on; c.classList.toggle("on", on); }
      }));
      const idx = s.done ? 4 : Math.max(0, Math.min(3, s.step || 0));
      const steps = s.steps || [];
      const status = s.done ? "HIT ENCONTRADO" : s.status || (steps[idx] ? steps[idx].s : "CARGANDO");
      el.status.forEach((n) => setText(n, status));
      el.sr.forEach((n) => setText(n, status.toLowerCase()));
      el.step.forEach(([n, m], i) => {
        const st = i < idx ? 2 : i === idx ? 1 : 0;
        if (n._st !== st) { n._st = st; n.dataset.st = st; }
        setText(m, st === 2 ? "✓" : st === 1 ? (REDUCED ? "◐" : MARKS[Math.floor(t * 8) % 4]) : "··");
      });
    };
    const start = () => { if (!raf) raf = requestAnimationFrame(loop); };
    const stop = () => { cancelAnimationFrame(raf); raf = 0; };
    const onVis = () => (document.hidden ? stop() : start());
    document.addEventListener("visibilitychange", onVis);
    start();
    return () => { stop(); document.removeEventListener("visibilitychange", onVis); };
  }, [rootRef, stateRef]);
}
